<template>
  <div class="[ c-cookie-banner__button-area ]">
    <button type="button" class="[ c-cookie-banner__details-button ]" v-on:click="showDetails()" v-html="$t(detailButtonText)"/>
    <button v-on:click="submitCookies()" class="[ c-cookie-banner__button  c-cookie-banner__button--primary ]">
      {{ $t('banner.buttons.save') }}
    </button>
    <button v-on:click="activateAllCookies()" class="[ c-cookie-banner__button  c-cookie-banner__button--secondary ]">
      {{ $t('banner.buttons.accept') }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'ButtonArea',
  data: function () {
    return {
      details: false
    }
  },
  computed: {
    detailButtonText: function () {
      return this.details
        ? 'banner.buttons.details.open'
        : 'banner.buttons.details.closed'
    }
  },
  methods: {
    submitCookies: function () {
      this.$emit('submit_selected')
    },
    activateAllCookies: function () {
      this.$emit('activate_all')
    },
    showDetails: function () {
      this.details = !this.details
      this.$emit('show_details')
    }
  }
}
</script>
